<template>
  <div class="live-acquisition-summary">
    <q-inner-loading :showing="visible">
      <q-spinner size="50px" color="secondary" />
    </q-inner-loading>
    <!-- Will need to add conditions to show / hide if content missing -->
    <div class="live-acquisition-summary__section">
      <div class="label">Last Updated:</div>
      <div class="value">{{ formatDateTime(this.lastUpdated) }}</div>
    </div>
    <div class="live-acquisition-summary__section">
      <div class="label">Registrations:</div>
      <div class="value">
        {{ count(this.registrations) }}
      </div>
    </div>
    <div class="live-acquisition-summary__section">
      <div class="label">1st Time Regs:</div>
      <div class="value">
        {{ count(this.firstTimeRegistrations) }}
        <span
          >{{
            formatPercentageWithBrackets(this.firstTimeRegistrationsPercentage)
          }}
        </span>
      </div>
    </div>
    <div class="live-acquisition-summary__section">
      <div class="label">Avg. Regs per User:</div>
      <div class="value">
        {{ formatDecimal(this.averageRegistrationsPerUser) }}
      </div>
    </div>
    <div class="live-acquisition-summary__section">
      <div class="label">FTDs:</div>
      <div class="value">
        {{ count(this.FTD) }}
        <span>{{ formatPercentageWithBrackets(this.FTDPercentage) }}</span>
      </div>
    </div>
    <div class="live-acquisition-summary__section">
      <div class="label">1st Time Deposits:</div>
      <div class="value">
        {{ count(this.firstTimeDepositors) }}
        <span>{{
          formatPercentageWithBrackets(this.firstTimeDepositorsPercentage)
        }}</span>
      </div>
    </div>
    <div class="live-acquisition-summary__section">
      <div class="label">Avg. FTD Value:</div>
      <div class="value">
        {{ formatCurrency(this.averageFTDValue) }}
      </div>
    </div>
  </div>
</template>
<script>
import { formatDateTime } from "@/utils/formatDate";
import { formatDecimal, count } from "@/utils/formatNumbers";
import { formatPercentageWithBrackets } from "@/utils/formatPercentage";
import { formatCurrency } from "@/utils/formatCurrency";
export default {
  name: "LiveAcquistionSummary",
  props: {
    dataset: String,
    filter: Object,
  },
  data() {
    return {
      visible: true,
      interval: null,
      lastUpdated: null,
      registrations: null,
      firstTimeRegistrations: null,
      firstTimeRegistrationsPercentage: null,
      averageRegistrationsPerUser: null,
      FTD: null,
      FTDPercentage: null,
      firstTimeDepositors: null,
      firstTimeDepositorsPercentage: null,
      averageFTDValue: null,
    };
  },

  methods: {
    formatDateTime,
    formatDecimal,
    count,
    formatPercentageWithBrackets,
    formatCurrency,
    async fetchData(siteId, networkId, operatorId) {
      // Dataset name is the store procedure name used to return the results.
      const payload = {
        filterOptions: {
          siteIds: siteId ? [siteId] : [],
          networkId,
          operatorId,
        },
        report: "live-acquisition",
        dataset: this.$props.dataset.replace(/ /g, ""),
      };

      await this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          this.lastUpdated = response.data[0].LastUpdated;
          this.registrations = response.data[0].Registrations;
          this.firstTimeRegistrations = response.data[0].FirstTimeRegistrations;
          this.firstTimeRegistrationsPercentage =
            response.data[0].FirstTimeRegistrationsPercentage;
          this.averageRegistrationsPerUser =
            response.data[0].AverageRegistrationsPerUser;
          this.FTD = response.data[0].FTD;
          this.FTDPercentage = response.data[0].FTDPercentage;
          this.firstTimeDepositors = response.data[0].FirstTimeDepositors;
          this.firstTimeDepositorsPercentage =
            response.data[0].FirstTimeDepositorsPercentage;
          this.averageFTDValue = response.data[0].AverageFTDValue;
          this.visible = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  watch: {
    filter: function(filterOption) {
      this.fetchData(
        filterOption.siteId,
        filterOption.networkId,
        filterOption.operatorId
      );
      this.visible = true;

      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.fetchData(
          filterOption.siteId,
          filterOption.networkId,
          filterOption.operatorId
        );
      }, 180000);
    },
  },
  mounted() {
    this.fetchData(
      this.$store.state.siteFilter.id,
      this.$store.state.networkFilter.id,
      this.$store.state.selectedOperator.id
    );
    this.visible = true;
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.fetchData(
        this.$store.state.siteFilter.id,
        this.$store.state.networkFilter.id,
        this.$store.state.selectedOperator.id
      );
    }, 180000);
  },
  // Prevent Memory Leak
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.live-acquisition-summary {
  height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &__section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    font-family: Barlow;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    .label {
      color: #030303;
    }
    .value {
      color: #747474;
      span {
        margin-left: 3px;
      }
    }
    &:nth-child(even) {
      background: rgba(69, 142, 221, 0.05);
    }
  }
}
// Dark Mode
.body {
  &--dark {
    .live-acquisition-summary {
      &__section {
        .label {
          color: #fff;
        }
        .value {
          color: #fff;
        }
        &:nth-child(even) {
          background: #353535;
        }
      }
    }
  }
}
</style>
